module.exports = __webpack_public_path__ + "f74756c7ab25d24d6d1dfc8c0d2b9d2b.pdf";